import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const PrintAware = styled.div`
  ${({ printable }) =>
    printable &&
    css`
      @media print {
        display: none;
      }
    `}
`;

PrintAware.propTypes = {
  printable: PropTypes.bool,
};

PrintAware.defaultProps = {
  printable: true,
};

export default PrintAware;
